<ng-container *ngIf="hasAddress">
  <div class="myaccount-delivery-wrapper">
    <h2>{{ 'personalInfo.deliveryAddress' | cxTranslate }}</h2>
    <div
      class="myaccount-personal-shipping-pending alert alert-info alert-dismissible fade show"
      role="alert"
      *ngIf="hasShippingPending"
    >
      <mat-icon class="material-icons-outlined">error_outline</mat-icon>
      {{ 'personalInfo.hasPendingShipping' | cxTranslate }}
    </div>
    <div class="myaccount-delivery-container">
      <ng-container *ngFor="let add of address.shippingAddress; count as addressCount">
        <div
          class="myaccount-delivery-address"
          [ngClass]="activeCountry$ | async"
          [ngClass]="
            add.defaultAddress && addressCount > 1 && (isChangeDefaultDeliveryAddressEnabled$ | async)
              ? 'myaccount-default-address'
              : 'myaccount-nondefault-address'
          "
          [class.disabled]="add?.approvalStatus === 'PENDING'"
          [class.change-disabled]="!(isChangeDefaultDeliveryAddressEnabled$ | async)"
          [class.cn]="!(isCountyEnabled$ | async)"
          [class.hide-checkbox-space]="(isChangeDefaultDeliveryAddressEnabled$ | async) && addressCount == 1"
        >
          <div
            class="column-2"
            [class.one-address]="!(addressCount > 1) && !(showAddressName$ | async)"
            [class.one-address-shown]="!(addressCount > 1) && (showAddressName$ | async)"
          >
            <div class="checkbox" *ngIf="(isChangeDefaultDeliveryAddressEnabled$ | async) && addressCount > 1">
              <mat-radio-button
                class=""
                value="add.addressId"
                (click)="add?.approvalStatus === 'APPROVED' && setDefaultAdd(add.addressId)"
                [checked]="add.defaultAddress ? 'checked' : null"
                [disabled]="add?.approvalStatus === 'PENDING'"
              ></mat-radio-button>
            </div>
            <div
              class="description"
              [ngClass]="activeCountry$ | async"
              [class.cn]="!(isChangeDefaultDeliveryAddressEnabled$ | async) && (activeCountry$ | async) === 'cn'"
            >
              <div class="myaccount-address-th">
                <span
                  class="myaccount-address-name"
                  *ngIf="
                    this.isDesktop && add.addressName && !(showAddressName$ | async);
                    else showDefaultAddressLabelOnDesktop
                  "
                  >{{ add.addressName }}</span
                >
                <ng-template #showDefaultAddressLabelOnDesktop>
                  <span class="myaccount-address-name" *ngIf="this.isDesktop">{{
                    'myAccount.address' | cxTranslate
                  }}</span>
                </ng-template>
                <span class="myaccount-address-name is-mobile" *ngIf="!this.isDesktop">{{
                  'myAccount.address' | cxTranslate
                }}</span>
                <span class="activate-default-address" *ngIf="add.defaultAddress">{{
                  'personalInfo.defaultDelivery' | cxTranslate
                }}</span>
              </div>
              <div class="myaccount-address-td" [innerHTML]="showAddress(add)"></div>
            </div>
          </div>
          <div class="column-3">
            <div class="myaccount-address-th">{{ 'personalInfo.postalCode' | cxTranslate }}</div>
            <div class="myaccount-address-td">{{ add.postalCode }}</div>
          </div>
          <div class="column-4">
            <div class="myaccount-address-th">{{ 'personalInfo.city' | cxTranslate }}</div>
            <div class="myaccount-address-td">{{ add.town }}</div>
          </div>
          <div class="column-5">
            <div class="myaccount-address-th">{{ 'personalInfo.state' | cxTranslate }}</div>
            <div class="myaccount-address-td">{{ (isCountyEnabled$ | async) ? add.region?.name : add.district }}</div>
          </div>
          <div class="column-6" *ngIf="isCountyEnabled$ | async">
            <div class="myaccount-address-th">{{ 'personalInfo.county' | cxTranslate }}</div>
            <div class="myaccount-address-td">{{ add.district }}</div>
          </div>
          <div class="column-7" [class.cn]="!(isCountyEnabled$ | async)">
            <div class="myaccount-address-th">{{ 'personalInfo.country' | cxTranslate }}</div>
            <div class="myaccount-address-td">{{ add.country?.name }}</div>
          </div>
          <div
            class="column-8"
            *ngIf="(isDeleteDeliveryAddressEnabled$ | async) && isChangeDefaultDeliveryAddressEnabled$ | async"
          >
            <button
              type="button"
              class="close"
              aria-label="Delete"
              (click)="deleteAddressModal(add.id)"
              [disabled]="add?.approvalStatus === 'PENDING'"
            >
              <mat-icon
                matTooltip="{{ 'buttonTooltip.myAccount.deleteEntry' | cxTranslate }}"
                [matTooltipPosition]="'below'"
                matTooltipClass="icon-tooltip"
                aria-label="displays a tooltip in bottom"
                class="mat-icon-rtl-mirror"
                [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
                >close</mat-icon
              >
            </button>
          </div>
        </div>
      </ng-container>

      <div
        class="myaccount-new-address"
        *ngIf="(isRequestNewDeliveryAddressEnabled$ | async) && isChangeDefaultDeliveryAddressEnabled$ | async"
      >
        <button
          class="tertiary-btn delete-cart"
          type="button"
          aria-haspopup="true"
          aria-expanded="false"
          (click)="onRequestNewDeliveryAddr()"
        >
          <mat-icon>add</mat-icon> {{ 'personalInfo.requestNewDelivery' | cxTranslate }}
        </button>
      </div>
    </div>
  </div>
  <div class="myaccount-billing-wrapper">
    <h2>{{ 'personalInfo.billingAddress' | cxTranslate }}</h2>
    <div
      class="myaccount-personal-billing-pending alert alert-info alert-dismissible fade show"
      role="alert"
      *ngIf="hasBillingPending"
    >
      <mat-icon class="material-icons-outlined">error_outline</mat-icon>
      <span>{{ 'personalInfo.hasPendingBilling' | cxTranslate }}</span>
    </div>
    <div class="myaccount-billing-container" [class.disabled]="hasBillingPending">
      <ng-container *ngFor="let add of address.billingAddress">
        <ng-container
          *ngIf="add.approvalStatus === 'APPROVED' && add.billingAddress && add.visibleInAddressBook; else approved"
        >
          <div
            class="myaccount-billing-address"
            [class.billing-pending]="hasBillingPending"
            [class.cn]="!(isCountyEnabled$ | async)"
          >
            <div class="column-2">
              <div class="myaccount-address-th">
                {{ 'myAccount.address' | cxTranslate }}
              </div>
              <div class="myaccount-address-td" [innerHTML]="showAddress(add)"></div>
            </div>
            <div class="column-3">
              <div class="myaccount-address-th">{{ 'personalInfo.postalCode' | cxTranslate }}</div>
              <div class="myaccount-address-td">{{ add?.postalCode }}</div>
            </div>
            <div class="column-4">
              <div class="myaccount-address-th">{{ 'personalInfo.city' | cxTranslate }}</div>
              <div class="myaccount-address-td">{{ add?.town }}</div>
            </div>
            <div class="column-5">
              <div class="myaccount-address-th">{{ 'personalInfo.state' | cxTranslate }}</div>
              <div class="myaccount-address-td">
                {{ (isCountyEnabled$ | async) ? add?.region?.name : add?.district }}
              </div>
            </div>
            <div class="column-6" *ngIf="isCountyEnabled$ | async">
              <div class="myaccount-address-th">{{ 'personalInfo.county' | cxTranslate }}</div>
              <div class="myaccount-address-td">{{ add?.district }}</div>
            </div>
            <div class="column-7" [class.cn]="!(isCountyEnabled$ | async)">
              <div class="myaccount-address-th">{{ 'personalInfo.country' | cxTranslate }}</div>
              <div class="myaccount-address-td">{{ add?.country?.name }}</div>
            </div>
            <div class="column-8">
              <button
                *ngIf="(isEditBillingAddressEnabled$ | async) && isChangeDefaultDeliveryAddressEnabled$ | async"
                mat-button
                disableRipple
                class="btn btn-billing-address"
                [disabled]="hasBillingPending"
                (click)="
                  updateBIllingAddressModal(
                    add?.country?.isocode,
                    add?.line1,
                    add?.line2,
                    add?.postalCode,
                    add?.town,
                    add?.region?.isocode,
                    add?.region?.name,
                    add?.district,
                    add?.firstName,
                    add?.lastName
                  )
                "
              >
                <mat-icon
                  matTooltip="{{ 'buttonTooltip.myAccount.editEntry' | cxTranslate }}"
                  [matTooltipPosition]="'below'"
                  matTooltipClass="icon-tooltip"
                  aria-label="displays a tooltip in bottom"
                  class="material-icons-sharp light billing-address"
                  [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
                  >create</mat-icon
                >
              </button>
            </div>
          </div>
        </ng-container>
        <ng-template #approved>
          <ng-container *ngIf="add.approvalStatus === 'APPROVED' && add.billingAddress && !hasBillingPending">
            <div class="myaccount-billing-address">
              <div class="column-2">
                <div class="myaccount-address-th">{{ 'myAccount.address' | cxTranslate }}</div>
                <div class="myaccount-address-td">{{ add?.line1 }} {{ add?.line2 }}</div>
              </div>
              <div class="column-3">
                <div class="myaccount-address-th">{{ 'personalInfo.postalCode' | cxTranslate }}</div>
                <div class="myaccount-address-td">{{ add?.postalCode }}</div>
              </div>
              <div class="column-4">
                <div class="myaccount-address-th">{{ 'personalInfo.city' | cxTranslate }}</div>
                <div class="myaccount-address-td">{{ add?.town }}</div>
              </div>
              <div class="column-5">
                <div class="myaccount-address-th">{{ 'personalInfo.state' | cxTranslate }}</div>
                <div class="myaccount-address-td">
                  {{ (isCountyEnabled$ | async) ? add?.region?.name : add?.district }}
                </div>
              </div>
              <div class="column-6" *ngIf="isCountyEnabled$ | async">
                <div class="myaccount-address-th">{{ 'personalInfo.county' | cxTranslate }}</div>
                <div class="myaccount-address-td">{{ add?.district }}</div>
              </div>
              <div class="column-7" [class.cn]="!(isCountyEnabled$ | async)">
                <div class="myaccount-address-th">{{ 'personalInfo.country' | cxTranslate }}</div>
                <div class="myaccount-address-td">{{ add?.country?.name }}</div>
              </div>
              <div class="column-8">
                <button
                  *ngIf="(isEditBillingAddressEnabled$ | async) && isChangeDefaultDeliveryAddressEnabled$ | async"
                  mat-button
                  class="btn btn-billing-address"
                  [disabled]="hasBillingPending"
                  (click)="
                    updateBIllingAddressModal(
                      add?.country?.isocode,
                      add?.line1,
                      add?.line2,
                      add?.postalCode,
                      add?.town,
                      add?.region?.isocode,
                      add?.region?.name,
                      add?.district,
                      add?.firstName,
                      add?.lastName
                    )
                  "
                >
                  <mat-icon
                    matTooltip="{{ 'buttonTooltip.myAccount.editEntry' | cxTranslate }}"
                    [matTooltipPosition]="'below'"
                    matTooltipClass="icon-tooltip"
                    aria-label="displays a tooltip in bottom"
                    class="material-icons-sharp light billing-address"
                    [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
                    >create</mat-icon
                  >
                </button>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </ng-container>
    </div>
  </div>
</ng-container>
